import {
  Box,
  Button,
  Text,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from "@chakra-ui/react";
import { MdArrowForward, MdCheckCircle, MdInfo } from "react-icons/md";
import { useState } from "react";

const NurseDropdown = ({ value, onChange, options, isRequired }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearchQuery] = useState("");

  const handleSelect = (nurseId) => {
    onChange(nurseId);
    onClose();
    setSearchQuery("");
  };

  const handleOpen = (e) => {
    e.stopPropagation();
    onOpen();
  };

  const filteredOptions = options.filter((nurse) => {
    const fullName = `${nurse.nom || ""} ${nurse.prenom || ""}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  return (
    <Box position="relative" onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
      <Menu isOpen={isOpen} onClose={onClose} closeOnBlur={false}>
        <MenuButton
          as={Button}
          rightIcon={<Icon as={MdArrowForward} transform={isOpen ? "rotate(-90deg)" : "rotate(90deg)"} />}
          w="100%"
          h="42px"
          borderRadius="6px"
          border="1px solid"
          borderColor="#E5E5E5"
          boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
          bg="white"
          textAlign="left"
          fontWeight="400"
          fontSize="13px"
          color={value ? "#455879" : "#656C7A"}
          onClick={handleOpen}
          _hover={{ bg: "white" }}
          _active={{ bg: "white" }}
        >
          {value ? (() => {
            const nurse = options.find(n => n.id === value);
            return nurse ? `${nurse.nom || ""} ${nurse.prenom || ""}`.trim() : "Sélectionner un infirmier";
          })() : "Sélectionner un infirmier"}
        </MenuButton>
        <MenuList
          maxH="400px"
          overflowY="auto"
          p="10px"
          borderRadius="6px"
          boxShadow="0px 0px 20px 0px rgba(0,0,0,0.1)"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
          zIndex={1000}
        >
          {/* Barre de recherche */}
          <Box mb="10px">
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <Icon as={MdInfo} color="#656C7A" w="16px" h="16px" />
              </InputLeftElement>
              <Input
                placeholder="Recherche d'une Infirmier..."
                value={searchQuery}
                onChange={(e) => {
                  e.stopPropagation();
                  setSearchQuery(e.target.value);
                }}
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                h="36px"
                borderRadius="6px"
                fontSize="13px"
                border="1px solid"
                borderColor="#E5E5E5"
              />
            </InputGroup>
          </Box>
          {filteredOptions.length === 0 ? (
            <Box p="14px" textAlign="center">
              <Text fontSize="13px" color="#656C7A">
                Aucun infirmier trouvé
              </Text>
            </Box>
          ) : (
            filteredOptions.map((nurse) => (
              <MenuItem
                key={nurse.id}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(nurse.id);
                }}
                bg={value === nurse.id ? "#EFF6FF" : "white"}
                border="1px solid"
                borderColor={value === nurse.id ? "rgba(69,156,233,0.2)" : "transparent"}
                borderRadius="6px"
                mb="5px"
                p="14px 20px"
              >
                <HStack justify="space-between" w="100%">
                  <Text fontSize="13px" color="#455879">
                    {nurse.nom} {nurse.prenom}
                  </Text>
                  {value === nurse.id && (
                    <Icon as={MdCheckCircle} w="16px" h="16px" color="#459CE9" />
                  )}
                </HStack>
              </MenuItem>
            ))
          )}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default NurseDropdown;
